import React from 'react';
import map from 'lodash.map';
import size from 'lodash.size';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import Locations from './Locations';
import Matches from './Matches';
import Loading from '../Common/Loading';
import * as Maps from '../../store/map';

class InPlay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: 400,
            skipe: 0,
            take: 8,
            drawMatches: [],
            hasMore: false,
            isLoading: false,
        };

        this.selector = React.createRef();
    }

    componentDidMount() {
        const rect = this.selector.current.getBoundingClientRect();
        this.setState({
            height: rect.height - 55,
        });

        this.fetchMoreData(this.props, true);

        let cuurenttLoadingIsDone = this.checkLoadingIsDone(this.props);

        if (cuurenttLoadingIsDone === false) {
            this.setState({ isLoading: true });
        }
    }

    checkLoadingIsDone = (props) => {
        let { isLoadingStarted, loadedCount, desiredLoadCount } = props.lSports.inplay;
        return isLoadingStarted && loadedCount >= desiredLoadCount;
    };

    componentWillReceiveProps(nextProps) {
        let { mainFilteredEvents, selectedSport } = this.props.lSports.inplay;

        if (mainFilteredEvents !== nextProps.lSports.inplay.mainFilteredEvents) {
            this.fetchMoreData(nextProps, true);
        }

        let cuurenttLoadingIsDone = this.checkLoadingIsDone(this.props);
        let nextLoadingIsDone = this.checkLoadingIsDone(nextProps);

        if (cuurenttLoadingIsDone && nextLoadingIsDone && this.state.isLoading) {
            this.setState({ isLoading: false });
            this.props.lsportsActions.inplay.selectSport(selectedSport);
        } else if (cuurenttLoadingIsDone === false && this.state.isLoading === false) {
            this.setState({ isLoading: true });
        }
    }

    fetchMoreData = (props, clearOldData = false) => {
        let { take, skipe, drawMatches } = this.state;
        let { mainFilteredEvents } = props.lSports.inplay;
        let count = 0;
        let canSkipe = false;

        if (clearOldData !== true && skipe === 0) {
            skipe = skipe + take;
        }

        let nextMatches = map(mainFilteredEvents, (sport) => {
            return map(sport.Locations, (location) => {
                return map(location.Leagues, (league) => {
                    canSkipe = count >= skipe && count < skipe + take;
                    count++;

                    return size(league.Events) > 0 && canSkipe ? (
                        <Matches {...this.props} isLive={true} events={league.Events} key={'group_' + league.Id} />
                    ) : null;
                });
            });
        });

        let hasMore = skipe + take <= Math.floor(count / take) * take;

        this.setState({
            drawMatches: clearOldData ? [nextMatches] : [...drawMatches, nextMatches],
            skipe: clearOldData ? 0 : skipe + take,
            hasMore: hasMore,
        });
    };

    render() {
        let { drawMatches, height, hasMore, isLoading } = this.state;

        let drawContent = isLoading ? (
            <Loading />
        ) : (
            <div>
                <Locations />
                <InfiniteScroll
                    height={height}
                    dataLength={size(drawMatches)}
                    next={(e) => {
                        this.fetchMoreData(this.props);
                    }}
                    hasMore={hasMore}
                    loader={<h4>Loading...</h4>}
                >
                    {drawMatches}
                    <div className="pb-5"></div>
                </InfiniteScroll>
            </div>
        );

        return (
            <div className="main-container pt-2" id="myInplay" ref={this.selector}>
                {drawContent}
            </div>
        );
    }
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(InPlay);
